import * as yup from 'yup';

export const portabilityNumberSchema = () =>
  yup.object({
    phoneNumber: yup
      .string()
      .required('Campo obbligatorio')
      .min(9, 'Inserire un numero valido')
      .max(11, 'Inserire un numero valido')
      .matches(/^(3)+[0-9]*$/, 'Inserire un numero valido'),
  });
